import React, {Fragment} from 'react';
import Header from '../../components/header'
// import PageTitle from '../../components/pagetitle'
// import Casesection from '../../components/case2'
import Footer from '../../components/footer'
import Scrollbar from '../../components/scrollbar'
import Journal from '../../components/journal'

const Journals =() => {
    return(
        <Fragment>
            <Header/>
            {/* <PageTitle pageTitle={'Journals'} pagesub={'Journals'}/>  */}
            {/* <Mission subclass={'section-padding'}/> */}
            {/* <Awards highlightImage={awardImg}/> */}
            {/* <Casesection/> */}
            <Journal/>
            <Footer/>
            <Scrollbar/>
        </Fragment>
    )
};
export default Journals;
